import { API_BASE_URL } from "../config";
import { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/verify.scss";
import logo from "../access/img/MetrIQlogo.svg";
import Loader from "../components/Loader";

function VerifyCode() {
  const [codeDigits, setCodeDigits] = useState(["", "", "", "", "", ""]);
  const [message, setMessage] = useState("");
  const [resendMessage, setResendMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const location = useLocation();
  const navigate = useNavigate();

  const [userId, setUserId] = useState("");

  useEffect(() => {
    const id = location.state?.userId || localStorage.getItem("userId");
    if (id) {
      setUserId(id);
      localStorage.setItem("userId", id);
    } else {
      navigate("/login");
    }
  }, [location, navigate]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newDigits = [...codeDigits];
    newDigits[index] = value;
    setCodeDigits(newDigits);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !codeDigits[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);

    const code = codeDigits.join("");
    if (code.length !== 6) {
      setLoading(false);
      return setMessage("Please enter all 6 digits");
    }

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ userId, code }),
      });

      const data = await res.json();
      setLoading(false);

      if (res.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("role", data.role);
        localStorage.setItem("isVerified", "true");
        localStorage.removeItem("userId");
        navigate(
          data.role === "admin"
            ? "/admin/dashboard"
            : data.role === "user"
              ? "/user/dashboard"
              : "/login",
          { replace: true },
        );
      } else {
        setMessage(data.error || "Verification failed");
      }
    } catch (err) {
      setLoading(false);
      setMessage("An error occurred. Please try again.");
    }
  };

  const handleResend = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/resend-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ userId }),
      });

      const data = await res.json();
      setResendMessage(res.ok ? "Code resent successfully." : data.error);
    } catch (err) {
      setResendMessage("Failed to resend code.");
    }
  };

  return (
    <div className="verify-page">
      <div className="verify-box">
        <img src={logo} alt="Logo" className="logo" />
        <h2>Verify Your Login</h2>
        <p>We’ve sent a 6-digit verification code to your email address.</p>
        <p>Please enter the code below to complete your login.</p>

        <form onSubmit={handleVerify} className="code-form">
          <div className="code-inputs">
            {codeDigits.map((digit, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                ref={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              />
            ))}
          </div>
          <small>Enter the 6-digit code</small>
          <button type="submit" style={{ borderRadius: 30 }}>
            {loading ? <Loader size="18px" color="#fff" /> : "Verify Code"}
          </button>
        </form>

        {message && <p className="error-msg">{message}</p>}
        {resendMessage && <p className="resend-msg">{resendMessage}</p>}

        <p className="resend">
          Didn’t receive the code? Check your spam folder or{" "}
          <span className="resend-link" onClick={handleResend}>
            click here to resend
          </span>{" "}
          it after a minute.
        </p>
      </div>
    </div>
  );
}

export default VerifyCode;
